import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { usePaymentInstructions } from "../PaymentInstructionsContext";
import { createPaymentInstruction, description } from "./styles_vanilla.css";

const CreatePaymentInstruction = () => {
  const history = useHistory();
  const location = useLocation();
  const { readonly } = usePaymentInstructions();

  const handleClick = () => {
    history.push(`${location.pathname}/create`);
  };

  return (
    <Flex flexDirection="column" gap={Sizes.MD}>
      <Text variant="regular-md" className={description}>
        This case does not have any payment instructions configured
      </Text>
      <Button
        data-testid="create-payment-instruction"
        variant="neutral"
        icon="plus"
        className={createPaymentInstruction}
        onClick={handleClick}
        disabled={readonly}
      >
        Create Payment Instructions
      </Button>
    </Flex>
  );
};

export default CreatePaymentInstruction;
